export default function getHighQualityImageProductUtil (src) {
  src = src || ''
  const extension = src.slice(src.lastIndexOf('.'))
  return src.replace(extension, `_x720@2x${extension}`)
}
